import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Modal } from '@/components/shared/Modal';
import { Button } from '@/components/ui/button';

/**
 * Shown the moment a new location is created.
 *
 * A brand-new location has nobody at it, and the contact field silently empties
 * — which used to strand the operator with no indication that anything was
 * missing. Offering the next step here is the difference between a chain and a
 * dead end. Skip is a first-class answer: plenty of intakes never need a contact.
 */
export function AddContactPrompt({
  open,
  locationName,
  onAddContact,
  onSkip,
}: {
  open: boolean;
  locationName: string;
  onAddContact: () => void;
  onSkip: () => void;
}) {
  return (
    <Modal open={open} onClose={onSkip} title="Location added">
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <FontAwesomeIcon icon={faUser} className="mt-1 h-4 w-4 shrink-0 text-primary" />
          <div>
            <p className="text-sm font-semibold">Would you like to add a contact?</p>
            <p className="mt-1 text-[13px] text-muted-foreground">
              Nobody is on file at {locationName} yet. You can add someone now or carry on and do it
              later.
            </p>
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onSkip}>
            Skip
          </Button>
          <Button type="button" onClick={onAddContact}>
            Add Contact
          </Button>
        </div>
      </div>
    </Modal>
  );
}
